import React, { useState, useEffect } from "react";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function HelpSnackbar({ snack, setSnack }) {
  const [snackPack, setSnackPack] = useState([]);
  const [autohideDuraction, setAutoHideDuration] = useState(2000);

  /* In order to handle more than one snackbar */
  useEffect(() => {
    if (snackPack.length && !snack.text) {
      /* Set a new snack when we don't have an active one */
      setSnack({ ...snack, text: snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setSnack({ ...snack, open: true });
    } else if (snackPack.length && snack.text && snack.open) {
      /* Close an active snack when a new one is added */
      setSnack({ ...snack, open: false });
    }
    if ('autoHideDuration' in snack) {
      setAutoHideDuration(snack.autoHideDuration);
    }
  }, [snackPack, setSnack, snack]);

  /* Handle close and exit*/
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setSnack({ ...snack, open: false });
  };

  // const handleExited = () => {
  //     setSnack({ ...snack, text: ""});
  // };

  /* Severities: error, warning, info, success */
  return (
    <Snackbar
      open={snack.open}
      autoHideDuration={autohideDuraction}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
    >
      <Alert onClose={handleClose} severity={snack.type}>
        <div style={{ whiteSpace: 'pre-line' }}>
          {snack.text}
        </div>
        {snack.web !== undefined && (
          <a href={snack.web.url} target="_blank" rel="noreferrer">
            {snack.web.label}
          </a>
        )}
      </Alert>
    </Snackbar>
  );
}
